<template>
    <DashboardLayout :user="user">

        <div class="border border-gray-300 bg-white rounded-lg shadow-lg max-w-4xl mx-auto pb-10">

            <div class="bg-gray-200 text-lg font-semibold px-6 py-3 rounded-t-lg text-left">
                Update Profile
            </div>

            <div class="px-6 py-4 mt-5">

                <form @submit.prevent="otpSent ? validateOtp() : update()">

                    <div class="flex items-center mb-4">
                        <label class="w-1/3 text-gray-700 font-bold text-right pr-4">Name</label>
                        <div>{{ user.name }}</div>
                        <!-- <input v-model="username" type="text"
                            class="w-2/3 border rounded px-3 py-2 focus:ring focus:ring-blue-300"
                            placeholder="Enter Existing or New Username"> -->
                    </div>


                    <div class="flex items-center mb-4">
                        <label class="w-1/3 text-gray-700 font-bold text-right pr-4">New Password</label>
                        <div class="w-2/3">
                            <input v-model="password" type="password"
                                class="w-full border rounded px-3 py-2 focus:ring focus:ring-blue-300"
                                placeholder="Enter new password" @input="checkPasswordStrength">
                            <div class="password-strength">
                                <span
                                    :style="{ width: strengthPercentage + '%', backgroundColor: strengthColor }"></span>
                            </div>
                            <p class="text-sm mt-1 text-gray-500">{{ strengthMessage }}</p>
                        </div>
                    </div>

                    <div class="flex items-center mb-4">
                        <label class="w-1/3 text-gray-700 font-bold text-right pr-4">Old Password</label>
                        <input v-model="old_password" type="password"
                            class="w-2/3 border rounded px-3 py-2 focus:ring focus:ring-blue-300"
                            placeholder="Enter old Password">
                    </div>


                    <div class="flex items-center mb-4" v-if="otpSent">
                        <label class="w-1/3 text-gray-700 font-bold text-right pr-4">OTP</label>
                        <div class="w-2/3 flex gap-2 justify-between">
                            <OtpInput :otpLength="6" @updateOtp="otp = $event" />
                        </div>
                    </div>
                    <div class="flex justify-center mb-4" v-if="otpSent">
                        <p class="text-sm text-blue-600 cursor-pointer hover:underline"
                            @click="resendOtp"
                            :class="{ 'opacity-50 cursor-not-allowed': loadingButton === 'resendOtp' }">
                            <span v-if="loadingButton === 'resendOtp'">Resending...</span>
                            <span v-else>Resend OTP</span>
                        </p>
                    </div>


                    <p v-if="errorMessages" class="text-red-500 text-center mb-4">{{ errorMessages }}</p>
                    <p v-if="successMessage" class="text-green-500 mb-4">{{ successMessage }}</p>


                    <button type="submit"
                        class="h-10 px-5 m-2 rounded-lg bg-primary text-white py-2 rounded hover:bg-blue-600"
                        :disabled="loadingButton === 'update' || loadingButton === 'validateOtp'">
                        <span v-if="loadingButton === 'update'">Processing...</span>
                        <span v-else-if="loadingButton === 'validateOtp'">Validating...</span>
                        <span v-else>{{ otpSent ? 'Validate OTP' : 'Update' }}</span>
                    </button>
                </form>
            </div>
        </div>



    </DashboardLayout>

</template>

<script>


import { apiRequest } from "@/api";
import DashboardLayout from "@/components/DashboardLayout.vue";
import OtpInput from "@/components/OtpInput.vue";

export default {
    name: 'UpdateProfile',
    components: {
        DashboardLayout, OtpInput
    },
    data() {
        return {
            user: {},
            username: '',
            password: '',
            old_password: '',
            otp: '',
            otpSent: false,
            errorMessages: '',
            successMessage: '',
            strengthPercentage: 0,
            strengthColor: 'red',
            strengthMessage: '',
            loadingButton: null
        };
    },
    created() {
        const userData = localStorage.getItem('user');

        if (!userData) {
            alert("Session expired. Please log in again.");
            this.$router.push("/");
            return;
        }
        this.user = JSON.parse(userData);
    },
    methods: {
        checkPasswordStrength() {
            const password = this.password;

            let strength = 0;

            if (password.length >= 8) strength++; // Minimum length
            if (/[A-Z]/.test(password)) strength++; // Uppercase
            if (/[a-z]/.test(password)) strength++; // Lowercase
            if (/\d/.test(password)) strength++; // Numbers
            if (/[\W_]/.test(password)) strength++; // Special characters

            this.strengthPercentage = (strength / 5) * 100;
            switch (strength) {
                case 0:
                case 1:
                    this.strengthMessage = "Too Weak";
                    this.strengthColor = "red";
                    break;
                case 2:
                    this.strengthMessage = "Weak";
                    this.strengthColor = "orange";
                    break;
                case 3:
                    this.strengthMessage = "Moderate";
                    this.strengthColor = "yellow";
                    break;
                case 4:
                    this.strengthMessage = "Strong";
                    this.strengthColor = "green";
                    break;
                case 5:
                    this.strengthMessage = "Very Strong";
                    this.strengthColor = "darkgreen";
                    break;
            }
        },
        async update() {
            if (this.loadingButton) return;
            this.loadingButton = 'update';
            this.errorMessages = '';

            if (!this.password || !this.old_password) {
                this.showError('Password and Old Password are required');
                this.loadingButton = null;
                return;
            }

            if (this.strengthPercentage < 60) {
                this.showError('Password strength is too weak. Please create a stronger password.');
                return;
            }

            try {
                const response = await apiRequest('/request-update-otp', 'POST', {
                    password: this.password,
                    old_password: this.old_password,
                    acno: this.user.acno
                });

                if (response.data.status === 'success') {
                    this.mobile = response.data.mobile;
                    this.otpSent = true;
                } else {
                    this.showError(response.data.message || 'Failed to send OTP');
                }

            } catch (error) {
                const errorMessage = error.response && error.response.data && error.response.data.status === 'failure'
                    ? error.response.data.message
                    : 'Error sending OTP: ' + error.message;
                this.showError(errorMessage);
            } finally {
                this.loadingButton = null;
            }

        },
        async validateOtp() {
            if (this.loadingButton) return;
            this.loadingButton = 'validateOtp';
            this.errorMessages = '';

            if (this.otp.length !== 6) {
                this.showError('Enter a valid 6-digit OTP');
                this.loadingButton = null;
                return;
            }

            try {
                const response = await apiRequest('/otp-check', 'POST', {
                    mobile: this.mobile,
                    acno: this.user.acno,
                    password: this.password,
                    otp: this.otp,
                });

                if (response.data.status === 'success') {
                    this.successMessage = "Profile Updated. Please login with username and password."
                    setTimeout(() => {
                        localStorage.removeItem('token');
                        localStorage.removeItem('user');
                        this.$router.push('/');
                    }, 3000);
                } else {
                    this.showError(response.data.message || 'Failed to send OTP');
                }

            } catch (error) {
                const errorMessage = error.response && error.response.data && error.response.data.status === 'failure'
                    ? error.response.data.message
                    : 'Error sending OTP: ' + error.message;
                this.showError(errorMessage);
            } finally {
                this.loadingButton = null;
            }
        },
        async resendOtp() {
            if (this.loadingButton) return;
            this.loadingButton = 'resendOtp';

            try {
                const response = await apiRequest('https://net-banking.uat-api.dmcbank.co.in/resend-otp', 'POST', {
                    mobile: this.mobile,
                    context : 'registration'
                });

                if (response.data.status === 'success') {
                    this.successMessage = "OTP resent successfully";
                    setTimeout(() => { this.successMessage = ''; }, 3000);
                } else {
                    this.showError(response.data.message || 'Failed to resend OTP');
                }
            } catch (error) {
                this.showError(this.errorMessages = error.response?.data?.message || 'Error resending OTP');
            } finally {
                this.loadingButton = null;
            }
        },
        moveToNext(index, event) {
            if (event.target.value && index < 5) {
                this.$refs.otpInputs[index + 1].focus();
            }
        },
        moveToPrev(index, event) {
            if (!event.target.value && index > 0) {
                this.$refs.otpInputs[index - 1].focus();
            }
        },
        showError(message) {
            this.errorMessages = message;
            if (this.errorTimeout) {
                clearTimeout(this.errorTimeout);
            }
            this.errorTimeout = setTimeout(() => {
                this.errorMessages = '';
            }, 3000);
        },
    }
}

</script>

<style scoped>
.otp-box {
    width: 45px;
    height: 45px;
    font-size: 18px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
}

.password-strength {
    height: 5px;
    background-color: #ddd;
    border-radius: 4px;
    margin-top: 5px;
    overflow: hidden;
}

.password-strength span {
    display: block;
    height: 100%;
    transition: width 0.3s ease-in-out, background-color 0.3s ease-in-out;
}
</style>
